import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../../../components/AppBaseComponent';
import HttpAPICall from '../../../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Loader from "../../../../../components/ui/Loader/Loader";
import moment from 'moment';
import DatePicker from "react-datepicker";
import tapIcon from '../../../../../services/TapIcon';
import TapSelect from '../../../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';
import CounterlogModal from '../../../counterlog/CounterlogModal';
import InputTicketSearch from '../../../../includes/ui/InputTicketSearch';
import DateService from '../../../../../services/DateService';

class RunningStatusExecutionModal extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            execution_loading: false,
            selectedRowList: [],
            assetDetail: null,
            counterlog: null,
            executeForm: {},
            available_meters: [],
            isDisabled: false,
            latest_cl: [],
            form_data_loading: false,
            executeFormSubmitting: false,
            url: null,
            ticket_id: '',
            parameterOptions: [
                { value: 'ok', label: 'Checked and OK' },
                { value: 'required_attention', label: 'May Required Attention' },
                { value: 'required_immediateattention', label: 'Required Immediate Attention' }
            ],
            // Counterlog section state (for shift-table view)
            shift_cl: [],
            selectedRosterDetail: null,
            roster_loading: false,
            shifts: [],
            asset_meter: [],
            selectedShiftData: null,
            selectedDate: null,
            selectedTicket: null,
            // Flag to determine which UI to show
            hasCounterlogFromParent: false,
             isRefreshingShiftListing: false
        }
        this.modalId = uuid();
        this.CounterLogModalRef = React.createRef();
    }

    componentDidMount() {
        this.executionModal = new Modal(document.getElementById(this.modalId), { keyboard: false, backdrop: false });
    }

    executeModalInit = (selectedRowList, assetDetail, counterlog, disabled = true, url, ticketData) => {
        
        this.executionModal.show();
        this.loadFormData(selectedRowList, assetDetail, counterlog, disabled, url, ticketData);
    }

    loadFormData = (selectedRowList, assetDetail, counterlog, disabled, url, ticketData) => {
        this.setState({ form_data_loading: true });
        let params = {
            asset_id: assetDetail ? assetDetail.asset_id : '',
            counterlog_transaction_id: counterlog && counterlog.transaction_id ? counterlog.transaction_id : ''
        };
        
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/scs/execution_form_data', this.props.access_token, { ...params }, {}, (resp) => {
            let respData = resp.data;
            let shiftReading = {};
            (respData.cl_data || []).forEach((meter) => {
                shiftReading[meter.key] = meter.reading || '';
            });

            let ticket_id = '';
            let isTicketDisabled = false;
            let selectedTicket = null;
            if (ticketData && ticketData.activity_id) {
                ticket_id = ticketData.activity_id;
                isTicketDisabled = true;
                selectedTicket = {
                    value: ticketData.activity_id,
                    label: `${ticketData.activity_id} : ${ticketData.header}`,
                    display_label: `${ticketData.activity_id} : ${ticketData.header}`,
                    data: ticketData
                };
            }

            // Check if counterlog object exists from parent
            const hasCounterlogFromParent = counterlog && Object.keys(counterlog).length > 0;

            this.setState({
                selectedRowList: selectedRowList,
                url: url ? url : null,
                assetDetail: respData.asset ? respData.asset : null,
                counterlog: counterlog ? counterlog : null,
                available_meters: respData && respData.available_meters ? respData.available_meters : [],
                latest_cl: respData && respData.latest_cl ? respData.latest_cl : [],
                shift_cl: respData && respData.cl_data ? respData.cl_data : [],
                isDisabled: true,
                ticket_id: ticket_id,
                ticketData : ticketData,
                isTicketDisabled: isTicketDisabled,
                selectedTicket: selectedTicket,
                hasCounterlogFromParent: hasCounterlogFromParent,
                executeForm: {
                    shift_reading: shiftReading,
                    date_time: respData.cl_data?.find(r => r.key === 'feed_datetime')?.reading || '',
                    counterlog_transaction_id: hasCounterlogFromParent ? (counterlog?.transaction_id || '') : ''
                }
            }, () => {
                // Only load shift listing if no counterlog from parent
                if (!hasCounterlogFromParent && this.state.executeForm.date_time) {
                    this.getShiftListing(moment(this.state.executeForm.date_time).format('YYYY-MM-DD'));
                }
                this.setState({ form_data_loading: false });
            });
        }).catch(() => {
            this.setState({ form_data_loading: false });
        });
    }

    getShiftListing = (date_time) => {
        if (!this.state.assetDetail?.asset_id) return;
        
        this.setState({ roster_loading: true });
        let params = {
            date_range_start: date_time,
            date_range_end: date_time
        };
        
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/v2/monthly_logsheet/' + this.state.assetDetail.asset_id, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                selectedRosterDetail: respData.data,
                shifts: respData.shifts || [],
                asset_meter: respData.asset_meter || [],
            });
        }).finally(() => {
            this.setState({ roster_loading: false });
        });
    }

    handleCounterlogChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            executeForm: {
                ...prevState.executeForm,
                shift_reading: {
                    ...prevState.executeForm.shift_reading,
                    [name]: value
                }
            }
        }));
    };

    handleDateChange = (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
        this.setState(prevState => ({
            executeForm: {
                ...prevState.executeForm,
                date_time: formattedDate,
                counterlog_transaction_id: null
            }
        }), () => {
            if (date && !this.state.hasCounterlogFromParent) {
                this.getShiftListing(moment(date).format('YYYY-MM-DD'));
            }
        });
    };

    updateCounterlogModalInit = (shiftData, date) => {
        this.setState({
            selectedShiftData: shiftData,
            selectedDate: date
        }, () => {
            if (this.CounterLogModalRef.current) {
                this.CounterLogModalRef.current.updateCounterlogInit(
                    shiftData, 
                    date, 
                    this.state.assetDetail
                );
            }
        });
    }

   afterUpdateCounterlogSubmit = (date, asset_id, refresh_asset_card = true) => {
    
    if (date && this.state.executeForm.date_time && date == DateService.dateTimeFormat(this.state.executeForm.date_time,'YYYY-MM-DD') && !this.state.hasCounterlogFromParent) {
        this.getShiftListing(moment(date).format('YYYY-MM-DD'));
        
    }
}


    submitExecuteFormHandler = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let execute_data = [];

        this.state.selectedRowList.forEach((scs, index) => {
            let executeItem = {
                scs_setting_id: scs.id
            };

            if (scs.feedback_comment && scs.feedback_comment.trim() !== '') {
                executeItem.remark = scs.feedback_comment;
            }

            if (scs.enable_parameter === "Y") {
                let parameterObj = {};
                
                if (scs.parameter && scs.parameter.type === "range") {
                    if (scs.execute_level) {
                        parameterObj.execute_level = scs.execute_level.toString();
                    }
                } else {
                    if (scs.execute_val) {
                        parameterObj.execute_val = scs.execute_val;
                    }
                }
                
                if (Object.keys(parameterObj).length > 0) {
                    executeItem.parameter = parameterObj;
                }
            }

            execute_data.push(executeItem);
        });

        let frmData = {
            execute_data: execute_data
        };

        // Add counterlog_transaction_id if present (from either UI mode)
        if (this.state.executeForm.counterlog_transaction_id) {
            frmData.counterlog_transaction_id = this.state.executeForm.counterlog_transaction_id;
        }

        if (this.state.ticket_id && this.state.ticket_id.trim() !== '') {
            frmData.ticket_id = this.state.ticket_id;
        }

        this.setState({ executeFormSubmitting: true });
        HttpAPICall.withAthorization('POST', IAM_API_BASE_URL_2 + '/scs/execute_with_counterlog', this.props.access_token, {}, frmData, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.executionModal.hide();
            if (this.props.afterExecutionSubmit) {
                this.props.afterExecutionSubmit(this.state.selectedRowList.map(s => s.id));
            }
        }).finally(() => {
            this.setState({ executeFormSubmitting: false });
        });
    }

    // Simple counterlog UI similar to CounterlogExecutionModal.js
    renderSimpleCounterlogSection = () => {
        const { executeForm, isDisabled, available_meters, latest_cl, shift_cl } = this.state;

        return (
            <div className='counterlog mt-3'>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Counterlog</span>
                </div>
                
                {available_meters.map((meter, i) => {
                    const prevMeter = shift_cl ? shift_cl.filter(r => r.key === meter.key)[0] : null;
                    const latestMeter = latest_cl ? latest_cl.find(r => r.key === meter.key) : null;
                    
                    return (
                        <div key={i} className="row my-2">
                            <label className="col-sm-3 text-sm require pt-2">
                                <b>{meter.label}</b> ({meter.unit})
                            </label>
                            <div className="col-sm-4">
                                <input
                                    className="form-control"
                                    disabled={isDisabled}
                                    style={{ height: "30px", fontSize: "93%" }}
                                    name={meter.key}
                                    autoComplete='off'
                                    value={executeForm.shift_reading?.[meter.key] ?? ''}
                                    onChange={this.handleCounterlogChange}
                                />
                            </div>
                            <label className="col-sm-5 form-text">
                                {latestMeter && JSON.stringify(latestMeter) !== JSON.stringify(prevMeter) && (
                                    <small className="form-text">Latest Reading : {latestMeter.reading}</small>
                                )}
                            </label>
                        </div>
                    );
                })}
                
                <div className="row my-2">
                    <label className="col-sm-3 text-sm require pt-2">
                        <b>Counterlog Date</b>
                    </label>
                    <div className="col-sm-4">
                        <DatePicker
                            selected={executeForm && executeForm.date_time ? moment(executeForm.date_time).toDate() : null}
                            onChange={this.handleDateChange}
                            name="date_time"
                            className={"form-control"}
                            showMonthDropdown
                            showYearDropdown
                            autoComplete="off"
                            scrollMonthYearDropdown
                            placeholderText="Please Select Counterlog Date"
                            showTimeSelect
                            timeIntervals={5}
                            timeCaption="Time"
                            required={true}
                            popperPlacement="right-start"
                            dateFormat="dd-MMM-yyyy hh:mm a"
                            disabled={isDisabled}
                        />
                    </div>
                    <label className="col-sm-5 form-text">
                        {latest_cl?.find(r => r.key === 'feed_datetime')?.reading && (
                            <small className="form-text">
                                Latest Reading: {moment(latest_cl.find(r => r.key === 'feed_datetime').reading).format('DD-MMM-YYYY hh:mm A')}
                            </small>
                        )}
                    </label>
                </div>
            </div>
        );
    }

    // Complex shift-table counterlog UI (existing)
    renderShiftTableCounterlogSection = () => {
        const { executeForm, isDisabled, roster_loading, selectedRosterDetail, asset_meter, latest_cl } = this.state;
           let minDate = null;
    let maxDate = null;
    let minTime = null;
    let maxTime = null;
    
    if (this.state.ticketData) {
        // Handle min date from start_date
        if (this.state.ticketData.start_date) {
            minDate = moment(this.state.ticketData.start_date, 'YYYY-MM-DD HH:mm:ss').toDate();
            
            // Extract time from start_date for minTime
            const startMoment = moment(this.state.ticketData.start_date, 'YYYY-MM-DD HH:mm:ss');
            minTime = startMoment.toDate();
        }
        
        // Handle max date from closure_date
        if (this.state.ticketData.closure_date) {
            maxDate = moment(this.state.ticketData.closure_date, 'YYYY-MM-DD').toDate();
            
            // Extract time from closure_date if it has time, otherwise end of day
            if (this.state.ticketData.closure_date.includes(':')) {
                maxTime = moment(this.state.ticketData.closure_date, 'YYYY-MM-DD HH:mm:ss').toDate();
            } else {
                // If only date, set maxTime to end of that day
                maxTime = moment(this.state.ticketData.closure_date, 'YYYY-MM-DD').endOf('day').toDate();
            }
        } else {
            // If no closure date, max date is today
            maxDate = new Date();
            maxTime = new Date(); // Current time
        }
    }
    
        return (
            <div className='counterlog mt-3'>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Counterlog</span>
                </div>

                <div className="row my-2">
                    <label className="col-sm-3 text-sm pt-2">
                        <b>Counterlog Date</b>
                    </label>
                    <div className="col-sm-9 add_calender_section">
                        <DatePicker
                            selected={executeForm?.date_time ? moment(executeForm.date_time).toDate() : null}
                            onChange={this.handleDateChange}
                            name="date_time"
                            className={"form-control"}
                            showMonthDropdown
                            showYearDropdown
                            autoComplete="off"
                            scrollMonthYearDropdown
                            placeholderText="Please Select Counterlog Date"
                            required={false}
                            popperPlacement="top"
                            dateFormat="dd-MMM-yyyy"
                            minDate={minDate}
                        maxDate={maxDate}
                        minTime={minTime}
                        maxTime={maxTime}

                           // disabled={isDisabled}
                        />
                        <tapIcon.imageIcon
                            icon={tapIcon.CalenderIcon}
                            alt="counterlog_date"
                            className="add_calender-icon"
                        />
                    </div>
                </div>
                
                <div className="row my-1">
                    <div className="col-sm-9 offset-sm-3">
                        {latest_cl?.find(r => r.key === 'feed_datetime')?.reading && (
                            <small className="form-text text-muted">
                                Latest Reading: {moment(latest_cl.find(r => r.key === 'feed_datetime').reading).format('DD-MMM-YYYY hh:mm A')}
                            </small>
                        )}
                    </div>
                </div>

                {executeForm?.date_time && (
                    <div className="mt-3" style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered bg-white table-hover table-sm table-fixed mb-0">
                            <thead className='table-secondary text-center' style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr>
                                    <th style={{ width: "5%" }}></th>
                                    <th style={{ width: "20%" }}>Date</th>
                                    <th style={{ width: "30%" }}>Shift</th>
                                    <th style={{ width: "45%" }}>CounterLog Readings</th>
                                </tr>
                            </thead>
                            <tbody>
                                {roster_loading ? (
                                    <tr><td colSpan={4} className="text-center"><Loader /></td></tr>
                                ) : (
                                    selectedRosterDetail && selectedRosterDetail.length > 0 ? (
                                        selectedRosterDetail.map((day, i) => {
                                            let shiftsData = day?.logsheet?.shifts || [];
                                            return (
                                                <React.Fragment key={i}>
                                                    {shiftsData.map((sf, key) => {
                                                        let shift = this.state.shifts?.find(sh => sh.id == sf.shift_id);
                                                        const hasCounterlog = sf.transaction_id ? true : false;
                                                        
                                                        return (
                                                            <tr className="text-center" key={key}>
                                                                <td>
                                                                    <input
                                                                        type="radio"
                                                                        name="selected_counterlog"
                                                                        checked={executeForm.counterlog_transaction_id === sf.transaction_id}
                                                                        onChange={() => {
                                                                            let preFilledReadings = {};
                                                                            if (sf.cl && sf.cl.length > 0) {
                                                                                sf.cl.forEach(clItem => {
                                                                                    if (clItem.key !== 'feed_datetime') {
                                                                                        preFilledReadings[clItem.key] = clItem.reading;
                                                                                    }
                                                                                });
                                                                            }
                                                                            this.setState({
                                                                                executeForm: {
                                                                                    ...this.state.executeForm,
                                                                                    counterlog_transaction_id: sf.transaction_id,
                                                                                    shift_reading: {
                                                                                        ...this.state.executeForm.shift_reading,
                                                                                        ...preFilledReadings
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                        disabled={!hasCounterlog}
                                                                    />
                                                                </td>
                                                                {key === 0 && (
                                                                    <td className="align-middle" rowSpan={shiftsData.length}>
                                                                        {moment(day.date).format('DD-MMM-YYYY')}
                                                                    </td>
                                                                )}
                                                                <td className="align-middle">
                                                                    {shift?.shift_name || '-'}<br />
                                                                    <small>{shift?.shift_start || ''}</small>
                                                                </td>
                                                                <td className="align-middle">
                                                                    {hasCounterlog ? (
                                                                        sf.cl && sf.cl.length > 0 ? (
                                                                            sf.cl.filter(c => c.key !== 'feed_datetime').map((c, idx) => {
                                                                                let meter = asset_meter?.find(m => m.key === c.key);
                                                                                return (
                                                                                    <div key={idx} className="text-start">
                                                                                        <strong>{meter?.label || c.key}:</strong> {c.reading} {meter?.unit || ''}
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <span className="text-muted">No readings</span>
                                                                        )
                                                                    ) : (
                                                                        <a 
                                                                            role="button" 
                                                                            className="link-primary cursor_pointer"
                                                                            onClick={() => this.updateCounterlogModalInit(sf, day.date)}
                                                                        >
                                                                            No Record
                                                                        </a>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr><td colSpan={4} className="text-center">No Record Found</td></tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    render() {
        // Determine which counterlog UI to render
        const renderCounterlogUI = this.state.hasCounterlogFromParent 
            ? this.renderSimpleCounterlogSection() 
            : this.renderShiftTableCounterlogSection();

        return (
            <>
                <div className="modal fade" id={this.modalId} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Execute Service Checksheet</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                                {this.state.form_data_loading ? (
                                    <div className="text-center"><Loader /></div>
                                ) : (
                                    <div className=" my-3">
                                      {this.state.ticket_id &&  <div className="row my-3">
                                            <label className="col-sm-3 col-form-label col-form-label-sm">
                                                <b>Ticket ID</b>
                                            </label>
                                            <div className="col-sm-9">
                                                <InputTicketSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.setState({
                                                            ticket_id: selectedOption ? selectedOption.value : '',
                                                            selectedTicket: selectedOption
                                                        });
                                                    }}
                                                    placeholder="Search Ticket"
                                                    value={this.state.selectedTicket}
                                                    disabled={this.state.isTicketDisabled}
                                                    required={false}
                                                    search_asset_id={this.state.assetDetail ? this.state.assetDetail.asset_id : null}
                                                />
                                                {this.state.isTicketDisabled && this.state.selectedTicket && (
                                                    <small className="form-text text-muted">
                                                        Ticket is automatically linked from the current ticket
                                                    </small>
                                                )}
                                            </div>
                                        </div>}
                                        
                                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            <table className="table table-bordered bg-white align-items-center table-sm table-hover">
                                                <thead className="table-secondary">
                                                    <tr className="text-center">
                                                        <th scope="col" style={{ width: "5%" }}>S.No</th>
                                                        <th scope="col">Service Checksheet Name</th>
                                                        <th scope="col" style={{ width: "35%" }}>Parameter</th>
                                                        <th scope="col" style={{ width: "25%" }}>Remarks</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.execution_loading ? (
                                                        <tr><td colSpan={4} className="text-center"><Loader /></td></tr>
                                                    ) : (
                                                        this.state.selectedRowList && this.state.selectedRowList.length > 0 ? (
                                                            this.state.selectedRowList.map((sa, key) => {
                                                                return (
                                                                    <tr key={key + 1}>
                                                                        <td className='text-center'>{key + 1}</td>
                                                                        <td>{sa?.alias_name || sa?.name || "-"}</td>
                                                                        <td>
                                                                            {sa.enable_parameter === "Y" ? (
                                                                                <div>
                                                                                    {sa.parameter && sa.parameter.type === "range" ? (
                                                                                        <span>
                                                                                            <input
                                                                                                type="number"
                                                                                                className='form-control'
                                                                                                name="execute_level"
                                                                                                onChange={(e) => this.dynamicInputHandlerByKey(e, key, 'selectedRowList')}
                                                                                                value={this.state.selectedRowList[key]?.execute_level || ''}
                                                                                                placeholder={sa.parameter.type_display || ""}
                                                                                                style={{ height: "30px", fontSize: "93%" }}
                                                                                            />
                                                                                        </span>
                                                                                    ) : (
                                                                                        <TapSelect
                                                                                            changeEvent={(selectedOption) => {
                                                                                                let selectedRowList = [...this.state.selectedRowList];
                                                                                                selectedRowList[key] = {
                                                                                                    ...selectedRowList[key],
                                                                                                    execute_val: selectedOption ? selectedOption.value : ''
                                                                                                };
                                                                                                this.setState({ selectedRowList });
                                                                                            }}
                                                                                            options={this.state.parameterOptions}
                                                                                            isClearable={true}
                                                                                            value={this.state.parameterOptions.find(m => m.value === this.state.selectedRowList[key]?.execute_val)}
                                                                                            placeholder="Please Select Options"
                                                                                            containerHeight="30px"
                                                                                            fontSize="93%"
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            ) : "-"}
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                name="feedback_comment"
                                                                                className="form-control"
                                                                                placeholder="Remarks"
                                                                                onChange={(e) => {
                                                                                    let selectedRowList = [...this.state.selectedRowList];
                                                                                    selectedRowList[key] = {
                                                                                        ...selectedRowList[key],
                                                                                        feedback_comment: e.target.value
                                                                                    };
                                                                                    this.setState({ selectedRowList });
                                                                                }}
                                                                                value={this.state.selectedRowList[key]?.feedback_comment || ''}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr><td colSpan={4} className="text-center">No Service Checksheets Selected</td></tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Counterlog Section - Conditional UI */}
                                        {renderCounterlogUI}
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    disabled={this.state.executeFormSubmitting}
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.executeFormSubmitting || this.state.form_data_loading}
                                    onClick={this.submitExecuteFormHandler}
                                >
                                    Execute {this.state.executeFormSubmitting && (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-1" />)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Counterlog Modal - Only rendered/needed for shift-table view */}
                {!this.state.hasCounterlogFromParent && (
                    <CounterlogModal 
                        ref={this.CounterLogModalRef} 
                        afterSubmitCounterlog={(date, asset_id, refresh) => { 
                            this.afterUpdateCounterlogSubmit(date, asset_id, refresh);
                        }} 
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(RunningStatusExecutionModal);